import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ArticleService, PublicArticle } from '../services/article.service';

@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.css']
})
export class BlogDetailComponent implements OnInit, OnDestroy {
  article: PublicArticle | null = null;
  related: PublicArticle[] = [];
  loading = true;
  notFound = false;

  private routeSub?: Subscription;

  constructor(
    public articleService: ArticleService,
    private route: ActivatedRoute,
    private title: Title,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    // Re-load when navigating between articles (same component instance)
    this.routeSub = this.route.paramMap.subscribe(params => {
      const slug = params.get('slug') || '';
      this.load(slug);
    });
  }

  /** Hero uses the article cover, falling back to the default blog banner. */
  get heroImage(): string {
    const url = this.article?.cover_image
      ? this.articleService.coverUrl(this.article)
      : 'assets/img/banner/Komodo-6-scaled.webp';
    return `url("${url}")`;
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  private load(slug: string): void {
    this.loading = true;
    this.notFound = false;
    this.article = null;
    window.scrollTo({ top: 0 });

    this.articleService.getBySlug(slug).subscribe({
      next: (res) => {
        this.article = res.data;
        this.loading = false;
        this.title.setTitle(`${this.article.title} · East Indonesia Trip`);
        this.meta.updateTag({ name: 'description', content: this.article.excerpt || '' });
        this.loadRelated(this.article.id);
      },
      error: () => {
        this.loading = false;
        this.notFound = true;
        this.title.setTitle('Article not found · East Indonesia Trip');
      }
    });
  }

  private loadRelated(currentId: number): void {
    this.articleService.getPublished({ limit: 4 }).subscribe({
      next: (res) => {
        this.related = (res?.data ?? []).filter(a => a.id !== currentId).slice(0, 3);
      },
      error: () => (this.related = [])
    });
  }
}
